export const UserIconV2 = (props) => (
  <svg fill="none" height={15} viewBox="0 0 12 15" width={12} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M8.625 3.375C8.625 4.17065 8.30893 4.93371 7.74632 5.49632C7.18371 6.05893 6.42065 6.375 5.625 6.375C4.82935 6.375 4.06629 6.05893 3.50368 5.49632C2.94107 4.93371 2.625 4.17065 2.625 3.375C2.625 2.57935 2.94107 1.81629 3.50368 1.25368C4.06629 0.69107 4.82935 0.375 5.625 0.375C6.42065 0.375 7.18371 0.69107 7.74632 1.25368C8.30893 1.81629 8.625 2.57935 8.625 3.375ZM5.625 8.625C4.23261 8.625 2.89726 9.17812 1.91269 10.1627C0.928123 11.1473 0.375 12.4826 0.375 13.875H10.875C10.875 12.4826 10.3219 11.1473 9.33731 10.1627C8.35274 9.17812 7.01739 8.625 5.625 8.625Z"
      stroke="#A0A5AF"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.75}
    />
  </svg>
);
